import { FieldsEnum } from '@utils/fields/common';
import { isEmpty, isNil } from 'lodash';

/**
 * Gets a well formated address for the given user.
 *
 * @param {Object} user - The owner user.
 * @param {Object} options - Optional {shortFormat, streetSeparator, skipCountry}
 * @return {String} - The address.
 */
export default function addressDescription(user, options = {}) {
  if (isNil(user) || isNil(user.address)) {
    return FieldsEnum.EMPTY;
  }

  const macro = [
    user.address.suburb,
    user.address.state,
    user.address.postcode,
    options.skipCountry ? null : user.address.country,
  ].filter((field) => !!field).join(', ');

  const micro = [
    user.address.number,
    user.address.street,
  ].filter((field) => !!field);

  if (options.shortFormat || isEmpty(micro)) {
    return macro;
  }

  const streetSeparator = options.streetSeparator || '\n';

  return `${micro.join(' ')}${streetSeparator}${macro}`;
}
